export function getCurrencyByCountry(country: string): string {
  return country.toLowerCase() === "canada" ? "CAD" : "USD";
}
